'use client';

import { useSplitAndHeap } from '@/hooks/useSplitAndHeap';

interface AlertUsersProps {
	testId?: string;
}

const AlertUsers = (props: AlertUsersProps) => {
	const { testId = 'AlertUsers' } = props;
	const { AlertUsers: alertUsers } = useSplitAndHeap('AlertUsers');
	const config = alertUsers?.config ? JSON.parse(alertUsers.config) : {};

	if (!alertUsers || alertUsers.treatment !== 'on') return null;

	return (
		<div
			data-testid={testId}
			role="alert"
			className="fixed left-0 right-0 top-21 border-y border-red-400 bg-red-100 px-4 py-3 lg:px-6 lg:py-4"
		>
			<div className="flex gap-2 align-text-top">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
					className="h-auto w-5 shrink-0 stroke-red-600 lg:w-6"
				>
					<circle cx="12" cy="12" r="10" />
					<line x1="12" y1="16" x2="12" y2="12" />
					<line x1="12" y1="8" x2="12" y2="8" />
				</svg>
				<p className="flex-1 self-center text-sm text-red-600 lg:text-base">
					{config.message}
				</p>
			</div>
		</div>
	);
};

export default AlertUsers;
